<template>
    <PageComponent 
        :loader="loader" @showLoader="showLoader" @hideLoader="hideLoader"
        :addButtonLabel="addButtonLabel"
        @handleAddNew="addNewTopup"
        :searchFilters="searchFilters"
        @searchPage="searchTopups"
        @resetFilters="resetFilters"
        @removeItem="removeTopup"
        @removeSelectedItems="removeTopups"
        @printList="printTopupList"
        v-model:printModalVisible="printModalVisible"
        :printTitle="printTitle"
        :pdfUrl="pdfUrl"
        :addingRight="addingRight"
        :removingRight="removingRight"
        :rightsModule="rightsModule"
        :columns="tableColumns"
        :rows="topupsList"
        :actions="actions"
        :showTotals=true
        :idField="idField"
        @handleSelectionChange="handleSelectionChange"
        @handleActionClick="handleActionClick"
        @handleOpenLink="handleOpenLink"
        :count="depCount"
        :currentPage="currentPage"
        :result="depArrLen"
        @loadPrev="loadPrev"
        @loadNext="loadNext"
        @firstPage="firstPage"
        @lastPage="lastPage"
        :showNextBtn="showNextBtn"
        :showPreviousBtn="showPreviousBtn"
        :selectedValue="selectedValue"
        @selectSearchQuantity="selectSearchQuantity"
    />
    <MovableModal v-model:visible="depModalVisible" :title="title" :modal_top="modal_top" :modal_left="modal_left" :modal_width="modal_width"
        :loader="modal_loader" @showLoader="showModalLoader" @hideLoader="hideModalLoader"  @closeModal="closeModal">
        <DynamicForm 
            :fields="formFields" :flex_basis="flex_basis" :flex_basis_percentage="flex_basis_percentage" 
            :displayButtons="displayButtons" @handleSubmit="topupLoan" @handleReset="handleReset"
        />
    </MovableModal>
    <PrintModal v-model:visible="printModalVisible1" :title="printTitle1" >
        <iframe v-if="pdfUrl" :src="pdfUrl" width="100%" height="100%" type="application/pdf" style="border: none;"></iframe>
    </PrintModal>
</template>

<script>
import axios from "axios";
import { ref, computed, watch, onMounted, onBeforeMount } from 'vue';
import PageComponent from '@/components/PageComponent.vue'
import MovableModal from '@/components/MovableModal.vue'
import DynamicForm from '../NewDynamicForm.vue';
import { useStore } from "vuex";
import { useToast } from "vue-toastification";
import { useDateFormatter } from '@/composables/DateFormatter';
import PrintModal from '@/components/PrintModal.vue';

export default{
    name: 'Loan_Topups',
    components:{
        PageComponent,MovableModal,DynamicForm,PrintModal
    },
    setup(){
        const store = useStore();
        const toast = useToast();
        const { formatDate } = useDateFormatter();
        const current_date = new Date();
        const loader = ref('');
        const modal_loader = ref('none');
        const memComponentKey = ref(0);
        const prodComponentKey = ref(0);
        const title = ref('TopUp Details');
        const addButtonLabel = ref('New TopUp');
        const addingRight = ref('Adding Employee Loan TopUps');
        const removingRight = ref('Deleting Employee Loan TopUps');
        const rightsModule = ref('HR');
        const idField = 'empl_loan_topup_id';
        const depModalVisible = ref(false);
        const printModalVisible = ref(false);
        const pdfUrl = ref(null);
        const printTitle = ref('Print Loan TopUps List');
        const printModalVisible1 = ref(false);
        const printTitle1 = ref('Print Voucher');
        const selectedIds = ref([]);
        const topupsList = ref([]);
        const depResults = ref([]);
        const depArrLen = ref(0);
        const depCount = ref(0);
        const pageCount = ref(0);
        const selectedValue = ref(50);
        const currentPage = ref(1);
        const showNextBtn = ref(false);
        const showPreviousBtn = ref(false);
        const flex_basis = ref('');
        const flex_basis_percentage = ref('');
        const displayButtons = ref(true);
        const errors = ref([]);
        const modal_top = ref('170px');
        const modal_left = ref('400px');
        const modal_width = ref('30vw');
        const applicationArray = computed(() => store.state.Employee_Loan_Applications.applicationArr);
        const tableColumns = ref([
            {type: "checkbox"},
            {label: "Date", key: "date"},
            {label: "Staff No", key: "staff_number"},
            {label: "Employee Name", key: "employee_name"},
            {label: "Loan No", key: "old_loan_number"},
            {label: "New Loan No", key: "new_loan_number"},
            {label: "Amount", key: "amount", type: "number"},
            {label: "Jnl#", key: "journal_no"},
            {label: "Description", key: "description"},
        ])
        const actions = ref([
            {name: 'delete', icon: 'fa fa-trash', title: 'Delete TopUp', rightName: 'Deleting Employee Loan TopUps'},
        ])
        const companyID = computed(()=> store.state.userData.company_id);
        const userID = computed(()=> store.state.userData.user_id);
        const applicationID = ref('');
        const loan_number_search = ref('');
        const journal_number_search = ref('');
        const name_search = ref('');
        const staff_number_search = ref("");
        const searchFilters = ref([
            {type:'text', placeholder:"Jnl#...", value: journal_number_search, width:36,},
            {type:'text', placeholder:"Loan No...", value: loan_number_search, width:36,},
            {type:'text', placeholder:"Staff No...", value: staff_number_search, width:36,},
            {type:'text', placeholder:"Employee Name...", value: name_search, width:48,},
        ]);
        const handleSelectionChange = (ids) => {
            selectedIds.value = ids;
        };
        const fetchLoanApplications = async() =>{
            await store.dispatch('Employee_Loan_Applications/fetchLoanApplications', {company:companyID.value});
        };
        const handleSelectedApplication = async(option) =>{
            await store.dispatch('Employee_Loan_Applications/handleSelectedApplication', option)
            applicationID.value = store.state.Employee_Loan_Applications.applicationID;
        };
        const clearSelectedApplication = async() =>{
            await store.dispatch('Employee_Loan_Applications/updateState', {applicationID: ''});
            applicationID.value = store.state.Employee_Loan_Applications.applicationID;
        };

        const formFields = ref([]);
        const applicationValue = computed(() => {
            return applicationID.value;
        });
        const updateFormFields = () => {
            formFields.value = [
                {  
                    type:'search-dropdown', label:"Application", value: applicationValue.value, componentKey: memComponentKey,
                    selectOptions: applicationArray, optionSelected: handleSelectedApplication, required: true,
                    searchPlaceholder: 'Select Application...', dropdownWidth: '400px', updateValue: "",
                    clearSearch: clearSelectedApplication
                },
                { type: 'number', name: 'loan_balance',label: "Loan Balance", value: 0, required: true},
                { type: 'date', name: 'new_repayment_date',label: "Clearance Date", value: '', required: true },
                { type: 'number', name: 'loan_amount',label: "Loan TopUp Amount", value: 0, required: true},  
                { type: 'date', name: 'new_repayment_date',label: "Topup Date", value: '', required: true },
                { type: 'number', name: 'schedule_amount',label: "Schedule Amount", value: 0, required: false},      
                { type: 'number', name: 'installments',label: "Installments", value: 1, required: false},
                { type: 'date', name: 'new_repayment_date',label: "New Repayment Date", value: '', required: true },
                { type: 'text-area', name: 'loan_remarks',label: "Loan Remarks", value: null, required: false,textarea_rows: '3', textarea_cols: '56'}
            ];
        };
        const addNewTopup = () =>{
            updateFormFields();
            depModalVisible.value = true;
            handleReset();
            flex_basis.value = '1/3';
            flex_basis_percentage.value = '33.333';
        }
        const handleActionClick = async(rowIndex, action, row) =>{
            if(action == 'delete'){
                const accountID = [row[idField]];
                let formData = {
                    company: companyID.value,
                    loan_topup: accountID,
                    user: userID.value
                }
                await store.dispatch('Employee_Loan_Topups/deleteLoanTopup',formData).
                then(()=>{
                    searchTopups();
                })
            }
        } 
        const handleOpenLink = async(row) =>{

        }
        const handleReset = () =>{
            for(let i=0; i < formFields.value.length; i++){
                if(formFields.value[i].type == 'number'){
                    formFields.value[i].value = 0;
                }else{
                    formFields.value[i].value = '';
                }
                
            }
            applicationID.value = "";
            prodComponentKey.value += 1;
            memComponentKey.value += 1;

        }
        const showModalLoader = () =>{
            modal_loader.value = "block";
        }
        const hideModalLoader = () =>{
            modal_loader.value = "none";
        }
        const topupLoan = async() =>{
            showModalLoader();
            let formData = {
                loan_application: applicationID.value,
                loan_balance: formFields3.value[1].value,
                clearance_date: formFields3.value[2].value,
                loan_amount: formFields3.value[3].value,
                topup_date: formFields3.value[4].value,
                installments: formFields3.value[6].value,
                schedule_amount: formFields3.value[5].value,
                repayment_start_date: formFields3.value[7].value,
                loan_remarks: formFields3.value[8].value || null,
                user: userID.value,
                company: companyID.value
            }
            axios.post(`api/v1/recalculate-employee-loan-application/`,formData)
            .then((response)=>{
                if(response.data.msg == "Success"){
                    toast.success("Success")
                    closeModal();
                    searchTopups();
                }else{
                    toast.error("Error Topping Up Loan")
                }                  
            })
            .catch((error)=>{
                console.log(error.message);
                toast.error(error.message)
                hideModalLoader();
            })
            .finally(()=>{
                hideModalLoader();
            })
        
        };
        const removeTopup = async() =>{
            if(selectedIds.value.length == 1){
                let formData = {
                    company: companyID.value,
                    loan_topup: selectedIds.value,
                    user: userID.value
                }
                try{
                    const response = await store.dispatch('Employee_Loan_Topups/deleteLoanTopup',formData)
                    if(response && response.status == 200){
                        toast.success("Topup Removed Succesfully");
                        searchTopups();
                    }
                }
                catch(error){
                    console.error(error.message);
                    toast.error('Failed to remove Topup: ' + error.message);
                }
                finally{
                    selectedIds.value = [];
                }
            }else if(selectedIds.value.length > 1){
                toast.error("You have selected more than 1 Topup") 
            }else{
                toast.error("Please Select A Topup To Remove")
            }
        }
        const removeTopups = async() =>{
            if(selectedIds.value.length){
                let formData = {
                    company: companyID.value,
                    loan_topup: selectedIds.value,
                    user: userID.value
                }
                try{
                    const response = await store.dispatch('Employee_Loan_Topups/deleteLoanTopup',formData)
                    if(response && response.status == 200){
                        toast.success("Topup(s) Removed Succesfully");
                        searchTopups();
                    }
                }
                catch(error){
                    console.error(error.message);
                    toast.error('Failed to remove Topup(s): ' + error.message);
                }
                finally{
                    selectedIds.value = [];
                }
            }else{
                toast.error("Please Select A Topup To Remove")
            }
        }
        const showLoader = () =>{
            loader.value = "block";
        }
        const hideLoader = () =>{
            loader.value = "none";
        }
        const searchTopups = () =>{
            showLoader();
            showNextBtn.value = false;
            selectedIds.value = [];
            showPreviousBtn.value = false;
            let formData = {
                loan_number: loan_number_search.value,
                journal_no: journal_number_search.value,
                employee_name: name_search.value,
                staff_number: staff_number_search.value,
                company_id: companyID.value,
                page_size: selectedValue.value
            }
            axios
            .post(`api/v1/employee-loan-topups-search/?page=${currentPage.value}`,formData)
            .then((response)=>{
                topupsList.value = response.data.results;
                store.commit('Employee_Loan_Topups/LIST_TOPUPS', topupsList.value)
                depResults.value = response.data;
                depArrLen.value = topupsList.value.length;
                depCount.value = depResults.value.count;
                pageCount.value = Math.ceil(depCount.value / selectedValue.value);
                
                if(response.data.next){
                    showNextBtn.value = true;
                }
                if(response.data.previous){
                    showPreviousBtn.value = true;
                }
            })
            .catch((error)=>{
                console.log(error);
            })
            .finally(()=>{
                hideLoader();
            })
        };
        const selectSearchQuantity = (newValue) =>{
            selectedValue.value = newValue;
            searchTopups(selectedValue.value);
        };
        const loadPrev = () =>{
            if (currentPage.value <= 1){
                currentPage.value = 1;
            }else{
                currentPage.value -= 1;
            }
            
            searchTopups();
        }
        const loadNext = () =>{
            if(currentPage.value >= pageCount.value){
                currentPage.value = pageCount.value;
            }else if(currentPage.value < pageCount.value){
                currentPage.value += 1;
            }
            
            searchTopups();
        }
        const firstPage = ()=>{
            currentPage.value = 1;
            searchTopups();
        }
        const lastPage = () =>{
            currentPage.value = pageCount.value;
            searchTopups();
        }
        const resetFilters = () =>{
            currentPage.value = 1;
            selectedValue.value = 50;
            name_search.value = "";
            loan_number_search.value = "";
            staff_number_search.value = "";
            journal_number_search.value = "";
            searchTopups();
        };
        const closeModal = async() =>{
            depModalVisible.value = false;
            handleReset();
        }
        const printTopupList = () =>{
            showLoader();
            let formData = {
                loan_number: loan_number_search.value,
                journal_no: journal_number_search.value,
                employee_name: name_search.value,
                staff_number: staff_number_search.value,
                user: "",
                company_id: companyID.value,
            } 

            axios
            .post("api/v1/export-employee-loan-topups-pdf/", formData, { responseType: 'blob' })
                .then((response)=>{
                    if(response.status == 200){
                        const blob1 = new Blob([response.data], { type: 'application/pdf' });
                        const url = URL.createObjectURL(blob1);
                        pdfUrl.value = url;
                        printModalVisible.value = true;
                    }
                })
            .catch((error)=>{
                console.log(error.message);
            })
            .finally(()=>{
                hideLoader();
            })
        };
        onMounted(()=>{
            searchTopups();
            fetchLoanApplications();
        })
        return{
            title,idField, searchTopups, addButtonLabel, searchFilters, resetFilters, tableColumns, topupsList,
            currentPage,depResults, depArrLen, depCount, pageCount, showNextBtn, showPreviousBtn,modal_top, modal_left, modal_width,
            loadPrev, loadNext, firstPage, lastPage, actions, formFields, depModalVisible, addNewTopup,
            displayButtons,flex_basis,flex_basis_percentage, handleActionClick, handleReset, topupLoan,
            showLoader, loader, hideLoader, modal_loader, showModalLoader, hideModalLoader, removeTopup, removeTopups,
            addingRight,removingRight,rightsModule, closeModal,handleSelectionChange,selectSearchQuantity,selectedValue,
            printTopupList,printModalVisible,pdfUrl,printTitle,printModalVisible1,printTitle1,handleOpenLink
        }
    }
}
</script>